import React from "react";
import ReactDOM from "react-dom";
import { BaseURL } from "./Common";
import { Palette } from "../AppConfig";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Popper from "@material-ui/core/Popper";
import IconButton from "@material-ui/core/IconButton";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import LocationOffIcon from "@material-ui/icons/LocationOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import debounce from "lodash/debounce";
import BSL_Dialog from "./BSL_Dialog";
import { ContactsOutlined } from "@material-ui/icons";

const searchOptions = {
    componentRestrictions: { country: "au" },
    types: ["address"],
};

const styles = (theme) => ({
    root: {
        flex: "1",
        padding: "16px 16px 16px 8px",
    },
    label: {
        flex: "1",
        font: "14px " + theme.typography.fontFamily,
        fontWeight: theme.brand?.FIELDERS ? "700" : "200",
        color: Palette.Control.DarkGrey,
        padding: "4px 0px",
    },
    subtitle: {
        flex: "1",
        font: "13px " + theme.typography.fontFamily,
        color: "#6B8799",
        textAlign: "end",
        padding: "4px 0px",
    },
    autoComplete: {
        border: "1px",
        width: "100%",
    },
    formControlFull: {
        paddingRight: "5px",
        width: "100%",
    },
    formControl: {
        paddingRight: "5px",
    },
    helperText: {
        flex: "1",
        font: "13px " + theme.typography.fontFamily,
        color: Palette.Control.DarkGrey,
        textAlign: "start",
        padding: "4px 0px",
    },
    errorText: {
        flex: "1",
        font: "13px " + theme.typography.fontFamily,
        color: Palette.Control.Error,
        textAlign: "start",
        padding: "0px 0px",
        verticalAlign: "text-top",
        display: "flex",
        alignItems: "center",
    },
    mapCross: {
        position: "absolute",
        zIndex: "100",
        color: "white",
        marginLeft: "42%",
        marginTop: "80px",
        fontSize: "xx-large",
        userSelect: "none",
        pointerEvents: "none",
    },
    input: {
        padding: "2px",
        font: "14px " + theme.typography.fontFamily,
        padding: "10px 8px",
        border: "1px solid #6B8799",
        backgroundColor: "white",
    },
    textField: {
        borderRadius: "0px",
    },
    notchedOutline: {
        "&:focus": {
            borderWidth: "1px",
            borderColor: "#002D62 !important",
        },
    },
    disabled: {
        backgroundColor: Palette.Control.LightGrey,
    },
});

var reticleImage = null;
var originalLatLng = null;
if (window?.google?.maps) {
    originalLatLng = new window.google.maps.LatLng(-34.9389409, 138.5786031);
    reticleImage = new window.google.maps.MarkerImage(
        BaseURL("images/reticle.png"), // marker image
        new window.google.maps.Size(63, 63), // marker size
        new window.google.maps.Point(0, 0), // marker origin
        new window.google.maps.Point(32, 32)
    ); // marker anchor point
}
var reticleShape = {
    coords: [32, 32, 32, 32], // 1px
    type: "rect", // rectangle
};

var reticleMarker = null;

class AddressAutoComplete extends React.Component {
    constructor(props) {
        super(props);

        var in_showMap = props.showMap ? props.showMap : true;
        this.state = {
            showMap: in_showMap,
            openMapDragDialog: false,
            allowMapDrag: props.allowMapDrag,
            hasFocus: false,
        };
        this.map = null;
        this.addressInputRef = React.createRef();
    }

    componentDidMount() {
        this.map = new window.google.maps.Map(document.getElementById(this.props.id + "_map"), {
            streetViewControl: false,
            center: originalLatLng,
            zoom: 19,
            mapTypeId: window.google.maps.MapTypeId.HYBRID,
            draggable: this.state.allowMapDrag,
        });

        this.map.rotateControl = false;
        this.map.setTilt(0);

        var map = this.map;
        let onChangelatLng = this.props.onChangelatLng;

        reticleMarker = new window.google.maps.Marker({
            position: originalLatLng,
            map: map,
            icon: reticleImage,
            shape: reticleShape,
            optimized: false,
            zIndex: 5,
        });
        // debouncing the latlng changes so that if user moves on map continuously, only the latest coordinate after he pause is picked up
        const debouncedOnChangeLatLng = debounce((latLng) => {
            if (this.props.onChangelatLng) {
                this.props.onChangelatLng(latLng);
            }
        }, 2000);

        this.map.addListener("mouseup", function () {
            const latLng = { lat: map.getCenter().lat(), lng: map.getCenter().lng() };
            debouncedOnChangeLatLng(latLng);
        });
        this.map.addListener("bounds_changed", centerReticle);
        function centerReticle() {
            reticleMarker.setPosition(map.getCenter());
        }
    }

    toggleMap = () => {
        this.setState({ showMap: !this.state.showMap });
    };

    setBlur = (address) => {
        let _this = this;
        setTimeout(function () {
            _this.setState({ hasFocus: false });
        }, 250);

        let newAddress = {
            ...this.props.address,
            FormattedAddress: address,
        };

        if (this.props.onBlur) this.props.onBlur(newAddress);
    };

    handleApiLoaded = (map, maps) => {
        // use map and maps objects
        map.setMapTypeId("hybrid");
        map.rotateControl = false;
        map.setTilt(0);

        let onChangelatLng = this.props.onChangelatLng;
        this.map = map;

        if (onChangelatLng) {
            map.addListener("mouseup", function () {
                onChangelatLng({ lat: map.getCenter().lat(), lng: map.getCenter().lng() });
            });
        }
    };

    handleChange = (address) => {
        let newAddress = {
            ...this.props.address,
            FormattedAddress: address,
        };
        this.props.onChange(newAddress);
    };

    handleBlur = (address) => {
        let newAddress = {
            ...this.props.address,
            FormattedAddress: address,
        };
        this.props.onBlur(newAddress);
    };

    handleSelect = (address) => {
        let newAddress = {
            ...this.props.address,
            FormattedAddress: address,
        };
        this.props.onChange(newAddress);

        if (this.props.updateWind) {
            this.props.updateWind();
        }

        geocodeByAddress(address)
            .then((results) => {
                return getLatLng(results[0]);
            })
            .then((latLng) => {
                newAddress.LatLng = latLng;

                var sydney = new window.google.maps.LatLng(-33.867, 151.195);

                let map = this.map
                    ? this.map
                    : new window.google.maps.Map(document.getElementById("map"), { center: sydney, zoom: 19 });

                let onBlurEvent = this.props.onBlur;

                var service = new window.google.maps.places.PlacesService(map);
                service.textSearch({ query: address }, function (results, status) {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                        if (results.length > 0 && results[0].place_id) {
                            //get details
                            var request = {
                                placeId: results[0].place_id,
                                fields: ["address_components"],
                            };

                            service.getDetails(request, callback);

                            function callback(place, status2) {
                                if (status2 == window.google.maps.places.PlacesServiceStatus.OK) {
                                    for (var component of place.address_components) {
                                        if (component.types.includes("street_number"))
                                            newAddress.StreetNumber = component.long_name;
                                        if (component.types.includes("route")) {
                                            newAddress.Street = component.long_name;
                                            newAddress.Street_short_name = component.short_name;
                                        }
                                        if (component.types.includes("locality")) {
                                            newAddress.Suburb = component.long_name;
                                            newAddress.Suburb_short_name = component.short_name;
                                        }
                                        if (component.types.includes("administrative_area_level_1"))
                                            newAddress.State = component.short_name;
                                        if (component.types.includes("postal_code"))
                                            newAddress.PostCode = component.long_name;
                                    }
                                    onBlurEvent(newAddress);
                                }
                            }
                        }
                    } else {
                        onBlurEvent(newAddress);
                    }
                });

                if (this.map && this.props.enableMap) {
                    this.map.setCenter(new window.google.maps.LatLng(latLng.lat, latLng.lng));
                }
            })
            .catch((error) => {
                console.error("Error", error);
                this.props.onBlur(newAddress);
            });

        return;
    };

    render() {
        const { props } = this;
        const { address, classes, label_text, default_address, key, helperText, id, optional } = this.props;
        const { showMap, hasFocus } = this.state;
        let search_term = address["FormattedAddress"];
        let latLng = address["LatLng"];
        let showMapButton = this.props.enableMap ? (
            <InputAdornment position="end">
                <IconButton onClick={this.toggleMap}>{showMap ? <LocationOnIcon /> : <LocationOffIcon />}</IconButton>
            </InputAdornment>
        ) : (
            ""
        );

        if (this.map && showMap && address.LatLng) {
            this.map.setCenter(new window.google.maps.LatLng(address.LatLng.lat, address.LatLng.lng));
        }

        return (
            <PlacesAutocomplete
                key={id}
                value={address["FormattedAddress"]}
                onChange={this.handleChange}
                onSelect={this.handleSelect}
                onBlur={this.handleBlur}
                searchOptions={searchOptions}
                debounce={250}
                shouldFetchSuggestions={search_term && search_term.length > 4}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                    <div className={classes.root}>
                        {label_text && (
                            <div style={{ display: "flex", paddingBottom: "6px" }}>
                                <div className={classes.label}>{label_text}</div>
                                {optional && <div className={classes.subtitle}>Optional</div>}
                            </div>
                        )}
                        <TextField
                            {...getInputProps({
                                id: "AddressSearch" + key,
                                placeholder: "Search Places ...",
                            })}
                            className={classes.formControlFull}
                            inputRef={this.addressInputRef}
                            onFocus={() => this.setState({ hasFocus: true })}
                            onBlur={(e) => this.setBlur(e.target.value)}
                            inputProps={{
                                className: classes.input,
                            }}
                            InputProps={{
                                endAdornment: showMapButton,
                                classes: {
                                    root: classes.textField,
                                    disabled: classes.disabled,
                                },
                            }}
                            disabled={this.props.disabled}
                            style={{ width: "100%" }}
                        />
                        {(props.helperText || props.error) && (
                            <div style={{ display: "flex", padding: "8px 0px", flexDirection: "column" }}>
                                {props.error && (
                                    <div className={classes.errorText}>
                                        <ErrorOutlineIcon
                                            style={{ width: "16px", height: "16px", marginRight: "8px" }}
                                        />{" "}
                                        {props.error}
                                    </div>
                                )}
                                {props.helperText && <div className={classes.helperText}>{helperText}</div>}
                            </div>
                        )}
                        <div
                            id={id + "_map"}
                            className={latLng && showMap && this.props.enableMap ? "" : "hidden"}
                            style={{ width: "100%", height: "200px" }}
                            // onMouseDown={() => {
                            //     this.setState({ openMapDragDialog: true });
                            // }}
                        />
                        <div
                            id={id + "_map_reticle"}
                            className={
                                latLng && showMap && this.props.enableMap && !this.state.allowMapDrag ? "" : "hidden"
                            }
                            style={{
                                width: "80%",
                                height: "144px",
                                position: "relative",
                                marginTop: "-147px",
                                marginLeft: "59px",
                            }}
                            onMouseDown={() => {
                                if (!this.state.allowMapDrag) {
                                    this.setState({ openMapDragDialog: true });
                                }
                            }}
                        />
                        <BSL_Dialog
                            open={this.state.openMapDragDialog}
                            onClose={() => {
                                this.setState({ openMapDragDialog: false });
                            }}
                            button1Text="Allow Reposition"
                            button1Click={() => {
                                this.setState({ allowMapDrag: true, openMapDragDialog: false });
                                this.map.draggable = true;
                            }}
                            button2Text="Close"
                            button2Click={() => {
                                this.setState({ openMapDragDialog: false });
                            }}
                        >
                            This position is set automatically based on the Address. Would you like to fine tune the
                            location to the side of the structure you are designing for?
                        </BSL_Dialog>
                        <Popper
                            open={
                                true ||
                                ((loading ||
                                    suggestions.length > 0 ||
                                    (default_address && address !== default_address)) &&
                                    hasFocus)
                            }
                            anchorEl={
                                this?.addressInputRef?.current
                                    ? ReactDOM.findDOMNode(this.addressInputRef.current)
                                    : null
                            }
                            style={{ zIndex: 2000, minWidth: "550px" }}
                            placement={"bottom-start"}
                        >
                            <div className={classes.autoComplete + " autocomplete-dropdown-container"}>
                                {default_address &&
                                    default_address["FormattedAddress"] !== "" &&
                                    address["FormattedAddress"] !== default_address["FormattedAddress"] && (
                                        <div
                                            className="suggestion-item"
                                            onClick={(event) => this.handleSelect(default_address["FormattedAddress"])}
                                            style={{
                                                color: "red",
                                                fontSize: "0.75rem",
                                                cursor: "pointer",
                                                background: "white",
                                            }}
                                        >
                                            {default_address["FormattedAddress"]} (Customer Address)
                                        </div>
                                    )}
                                {loading && <div>Loading...</div>}
                                {suggestions.map((suggestion) => {
                                    const className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                        ? { backgroundColor: "#f5f5f5", cursor: "pointer" }
                                        : { backgroundColor: "#ffffff", cursor: "pointer" };
                                    return (
                                        <div
                                            {...getSuggestionItemProps(suggestion, {
                                                className,
                                                style,
                                            })}
                                        >
                                            <span
                                                style={{
                                                    font: "15px 'Univers45', sans-serif",
                                                    paddingLeft: "10px",
                                                }}
                                            >
                                                {suggestion.description}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </Popper>
                    </div>
                )}
            </PlacesAutocomplete>
        );
    }
}

export default withStyles(styles)(AddressAutoComplete);
